module.exports = __webpack_public_path__ + "static/media/zoom-in.7902c5cb.svg";